export const HOST_PREFIX = process.env.REACT_APP_HOST_PREFIX || "";

const ENDPOINT = {
  CALCULATE_TRAVEL_EXPENSES: HOST_PREFIX + "/api/expenses/calculateExpense",
  CALCULATE_WAGE: HOST_PREFIX + "/api/wages/calculateWage",
  TRAVEL_EXPENSES: HOST_PREFIX + "/api/travelExpenses",
  CURRENCY_RATES: HOST_PREFIX + "/api/rates",
  LOGIN_OKTA: HOST_PREFIX + "/oauth2/authorization/okta",
  LOGIN_GOOGLE: HOST_PREFIX + "/oauth2/authorization/google",
  LOGOUT: HOST_PREFIX + "/api/logout",
  GET_USER_INFO: HOST_PREFIX + "/api/users/currentUser",
  GET_ALL_USERS: HOST_PREFIX + "/api/users",
  SET_ADMIN_RIGHT: HOST_PREFIX + "/api/users/addAdminRole",
  REMOVE_ADMIN_RIGHT: HOST_PREFIX + "/api/users/removeAdminRole",
  REPORTS: HOST_PREFIX + "/api/reports",
  FILE: HOST_PREFIX + "/api/file"
};

export default ENDPOINT;
